export const DEFAULT_PAGE_QUERY = {
  page: 1,
  pageSize: 10,
  search: '',
};

export const PAGE_SIZE_OPTIONS = [
  {
    value: '5',
    label: '5',
  },
  {
    value: '10',
    label: '10',
  },
  {
    value: '20',
    label: '20',
  },
  {
    value: '50',
    label: '50',
  },
  {
    value: '100',
    label: '100',
  },
];

export const CLIENT_OPTION_TYPE = {
  BUDGET: 'BUDGET',
  SIZE: 'SIZE',
  INDUSTRY: 'INDUSTRY',
};


export const PAYMENT_STATUS = {
  PENDING: { label: 'Awaiting payment', color: 'blue' },
  FAILED: { label: 'Failed probation', color: 'red' },
  PAID: { label: 'Completed', color: 'green' },
  BREAK: { label: 'Candidate break', color: 'yellow' }
};


export const APPLICATION_PROCESS_NAMES = {
  SUBMITTED: 'Submitted',
  UNDER_REVIEW: 'Under review',
  INTERVIEW: 'Interview',
  HIRED: 'Hired',
  REJECTED: 'Rejected',
  CANCELLED: 'Cancelled',
  ON_HOLD: 'On hold',
  OFFER_MADE: 'Offer made',
  OFFER_ACCEPTED: 'Offer accepted',
}

export const STAGE_IDS = {
  PLACEMENT: 47,
  REJECTED: 49,
}